import { createFileRoute } from "@tanstack/react-router";

import { CampaignsPage } from "@/features/zdalny-dostep/campaigns-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/aktualizacje")({
	component: CampaignsPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.zdalny-dostep.aktualizacje",
			location.pathname,
		);
	},
});
